// @flow

// Mirrors Glassfrog::UrlField::ALLOWED_SCHEMES (app/lib/glassfrog/url_field.rb).
const ALLOWED_PROTOCOLS = [
  'http:', 'https:', 'mailto:', 'ftp:', 'file:', 'smb:',
  'ms-word:', 'ms-powerpoint:', 'ms-excel:', 'ms-visio:', 'ms-access:',
  'ms-project:', 'ms-publisher:', 'ms-spd:', 'ms-infopath:',
]

const sanitizeLinkUrl = (raw: ?string): ?string => {
  if (!raw)
    return null

  try {
    const {protocol} = new URL(raw)
    return ALLOWED_PROTOCOLS.includes(protocol) ? raw.trim() : null
  } catch (e) {
    return null
  }
}

// Mirrors Glassfrog::UrlField.safe_href: relative links pass, and any
// scheme-shaped prefix a browser would honour must be allowlisted.
// eslint-disable-next-line no-control-regex
const IGNORED_BY_BROWSERS = /^[\u0000-\u0020]+|[\t\n\r]/g
const HREF_SCHEME = /^([a-z][a-z0-9+.-]*:)/i
const IMAGE_PROTOCOLS = ['http:', 'https:']

const isSafeHref = (raw: ?string, protocols: Array<string> = ALLOWED_PROTOCOLS): boolean => {
  const match = (raw || '').replace(IGNORED_BY_BROWSERS, '').match(HREF_SCHEME)
  return !match || protocols.includes(match[1].toLowerCase())
}

export {isSafeHref, IMAGE_PROTOCOLS}
export default sanitizeLinkUrl
